import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType as NewEventType } from "@/features/events/types/EventType";
import { useHealthAssessment } from "@/features/health-assessment/hooks/useHealthAssessment";
import FolderCard from "@/features/shared/components/FolderCard";
import { useSurveyDataStore } from "@/utils/stores/useSurveyDataStore";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { saveEvent } from "../../../utils/apis/user-service";
import { EventType } from "../../../utils/enums/EventType";
import { QuestionCategory } from "../../../utils/enums/Surveys";
import { fromQuestionCategoryToString } from "../../../utils/Functions";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { useUserStore } from "../../../utils/stores/useUserStore";
import { useInitializeSurveyQuestions } from "../hooks/useInitializeSurveyQuesitions";

const HealthAssessment = () => {
    const { sendEvent } = useCreateEvent()
    const { isHealthAssessmentCompleted } = useHealthAssessment()
    const { healthAssessmentIds } = useInitializeSurveyQuestions()
    const { updateSurveyData } = useSurveyDataStore()
    const healthAssessmentCompleted = isHealthAssessmentCompleted()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const { userData } = useUserStore()
    const email = userData.email
    const navigate = useNavigate()

    useEffect(() => {
        if (!idToken || !email) return
        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "health_assessment_page",
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "blood_test_packing_page",
            event_metadata: { healthAssessmentCompleted: healthAssessmentCompleted }
        })

        if (healthAssessmentIds) {
            updateSurveyData({ healthAssessmentQuestions: healthAssessmentIds })
        }
    }, [])

    const categories = [
        QuestionCategory.PersonalGoals,
        QuestionCategory.FamilyHistoryDiseases,
        QuestionCategory.LifestyleSports,
        QuestionCategory.DietaryHabits,
        QuestionCategory.Notes,
        QuestionCategory.MonitoringPreferences,
    ];

    const onFolderClick = async (category: QuestionCategory) => {
        navigate(`category/${category}`)
        if (!email || !idToken) return
        saveEvent(
            email,
            `${category}_folder_clicked`,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "health_assessment_page",
        )
        await sendEvent({
            event: NewEventType.CLICK,
            sub_category: "health_assessment_category_folder_click",
            event_metadata: { category }
        })
    }


    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            <div className="flex flex-col space-y-sm">
                {
                    categories.map((category) => (
                        <FolderCard
                            key={category}
                            onClick={() => onFolderClick(category)} title={fromQuestionCategoryToString(category)}/>
                    ))
                }
            </div>
            <div className="p-[10px]" />
        </div>
    )
}

export default HealthAssessment
